import { render, staticRenderFns } from "./AddHub.vue?vue&type=template&id=83fbae08&scoped=true"
import script from "./AddHub.vue?vue&type=script&lang=js"
export * from "./AddHub.vue?vue&type=script&lang=js"
import style0 from "./AddHub.vue?vue&type=style&index=0&id=83fbae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fbae08",
  null
  
)

export default component.exports